
import { defineComponent , onMounted , ref } from 'vue'
import { getPageData } from "@/utils/api"
import { useStore } from 'vuex'
export default defineComponent({
    setup(){
        const store = useStore()
        let pageConfigTitle = ref('')
        onMounted(async () => {
            let domain = ''
            process.env.NODE_ENV === "development" ? domain = 'feiyicustomertestapi.51lg.cloud' : domain = window.location.host;
            const { code, data }:any = await getPageData({domain})
            // if(code !== 200) return store.commit('SET_PAGE_CONFIG',{})
            store.commit('SET_PAGE_CONFIG', {
                
            })
            pageConfigTitle.value = "灵工安心付-签约H5"
        })
        return {
            pageConfigTitle
        }
    },
})
